export default __webpack_public_path__ + "static/favicon-16x16-0396a2b4304e0eda373f8056a56f8a8b.png";